import type { TileChange, WamFile } from "@workadventure/map-editor";
import { PutTilesCommand } from "@workadventure/map-editor";
import type { GameMapFrontWrapper } from "../../../GameMap/GameMapFrontWrapper";
import type { FrontCommandInterface } from "../FrontCommandInterface";
import type { RoomConnection } from "../../../../../Connection/RoomConnection";

export class PutTilesFrontCommand extends PutTilesCommand implements FrontCommandInterface {
    constructor(
        wamFile: WamFile,
        tileChanges: TileChange[],
        commandId: string | undefined,
        private gameMapFrontWrapper: GameMapFrontWrapper,
    ) {
        super(wamFile, tileChanges, commandId);
    }

    public async execute(): Promise<void> {
        await super.execute();
        this.gameMapFrontWrapper.applyTileChanges(this.tileChanges);
    }

    public getUndoCommand(): PutTilesFrontCommand {
        const invertedChanges = this.tileChanges.map((change) => ({
            ...change,
            oldTile: change.newTile,
            newTile: change.oldTile,
        }));
        return new PutTilesFrontCommand(this.wamFile, invertedChanges, undefined, this.gameMapFrontWrapper);
    }

    public emitEvent(roomConnection: RoomConnection): void {
        roomConnection.emitMapEditorPutTiles(this.commandId, this.tileChanges);
    }
}
